import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        {/* Background Elements */}
        <div className="hero-bg">
          <div className="bg-gradient-1"></div>
          <div className="bg-gradient-2"></div>
          <div className="bg-dots"></div>
        </div>

        {/* Main Content */}
        <div className="hero-content">
          {/* Left Side - Text Content */}
          <div className="content-left">
            <div className="hero-badge">
              <span className="badge-dot"></span>
              <span>Türkiye'nin En Gelişmiş Salon Yönetim Sistemi</span>
            </div>
            
            <h1 className="hero-title">
              <span className="title-main">Salon</span>
              <span className="title-accent">Yönetimi</span>
              <span className="title-sub">Hiç Bu Kadar Kolay Olmamıştı</span>
            </h1>
            
            <p className="hero-description">
              Randevu takibinden muhasebe yönetimine kadar tüm süreçlerinizi 
              tek platformda yönetin. Modern, hızlı ve güvenilir.
            </p>



            {/* CTA Buttons */}
            <div className="cta-buttons">
              <a 
                href="https://play.google.com/store/apps/details?id=com.randevu345.app" 
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn primary"
              >
                <img src="/assets/googleplay.svg" alt="Google Play'den İndirin" />
              </a>
              
              <a 
                href="https://apps.apple.com/tr/app/randevu345/id6743093049" 
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn primary"
              >
                <img src="/assets/appstore.svg" alt="App Store'dan İndirin" />
              </a>
            </div>

            {/* Trust Badges */}
            <div className="trust-badges">
              <span className="trust-item">
                <span className="trust-icon">🛡️</span>
                <span>Veri Güvenliği</span>
              </span>
              <span className="trust-item">
                <span className="trust-icon">🕒</span>
                <span>7/24 Destek</span>
              </span>
              <span className="trust-item">
                <span className="trust-icon">⚡</span>
                <span>5 Dakikada Kurulum</span>
              </span>
            </div>
          </div>

          {/* Right Side - Phone Visual */}
          <div className="content-right">
            <div className="phone-section">
              {/* Background Elements */}
              <div className="phone-bg">
                <div className="bg-circle-1"></div>
                <div className="bg-circle-2"></div>
              </div>
              
              {/* Main Phone */}
              <div className="phone-container">
                <img 
                  src="/assets/telefon1-min.png" 
                  alt="Randevu345 Mobil Uygulama" 
                  className="phone-image"
                />
              </div>
              
              {/* Feature Bubbles */}
              <div className="stats-bubbles">
                <div className="stat-bubble bubble-1">
                  <div className="bubble-icon">🔒</div>
                  <div className="bubble-text">
                    <span className="bubble-label">Uçtan Uca</span>
                    <span className="bubble-value">Şifreli</span>
                  </div>
                </div>
                
                <div className="stat-bubble bubble-2">
                  <div className="bubble-icon">👥</div>
                  <div className="bubble-text">
                    <span className="bubble-label">Personel</span>
                    <span className="bubble-value">Yönetimi</span>
                  </div>
                </div>
                
                <div className="stat-bubble bubble-3">
                  <div className="bubble-icon">📱</div>
                  <div className="bubble-text">
                    <span className="bubble-label">SMS</span>
                    <span className="bubble-value">Bilgilendirme</span>
                  </div>
                </div>
                
                <div className="stat-bubble bubble-4">
                  <div className="bubble-icon">💰</div>
                  <div className="bubble-text">
                    <span className="bubble-label">Detaylı</span>
                    <span className="bubble-value">Muhasebe</span>
                  </div>
                </div>
                
                <div className="stat-bubble bubble-5">
                  <div className="bubble-icon">🌐</div>
                  <div className="bubble-text">
                    <span className="bubble-label">Web</span>
                    <span className="bubble-value">Sitesi</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 